import { useState } from 'react';
import { type Optional } from '@direct-frontend/stdlib';
import { type AggregatedOption } from '@/shared/api/order';

export const useOptionAvailability = (option: Optional<AggregatedOption>) => {
    const [lastAvailability, setLastAvailability] = useState<boolean>(true);

    if (option?.isAvailable !== undefined && option.isAvailable !== lastAvailability) {
        setLastAvailability(option.isAvailable);
    }

    return option?.isAvailable ?? lastAvailability;
};
